import { emptyObj } from '@beef/utils';
import { createSelector } from '@reduxjs/toolkit';
import { TARIFF_TYPES } from '@fttb/common';
import { POPUP_CONNECTION_STATE } from "../../../../../store/common/constants";
import { getQueryParams } from "../../utils/utils";
/*
 * TODO: В рамках задачи FIRST-1329 переименовать селекторы get => select
 * */
// селекторы для получения тарифа
export var getTargetTariffType = function getTargetTariffType(state) {
  return getModalTariffData(state).tariffType || emptyObj;
};
export var selectCommonData = function selectCommonData(state) {
  var _getModalTariffData;
  return ((_getModalTariffData = getModalTariffData(state)) === null || _getModalTariffData === void 0 ? void 0 : _getModalTariffData.popupData) || emptyObj;
};
export var getIsHighSpeedTariff = function getIsHighSpeedTariff(state) {
  return getTargetTariffType(state).isHighSpeedTariff;
};
export var getModalTariffData = function getModalTariffData(state) {
  var _state$modalsData;
  return ((_state$modalsData = state.modalsData) === null || _state$modalsData === void 0 ? void 0 : _state$modalsData.checkAddressOldPopup) || emptyObj;
};
export var getOrderTariffData = function getOrderTariffData(state) {
  return state.modalsData.orderTariffPopup || emptyObj;
};
export var getTargetTariffGroup = function getTargetTariffGroup(state) {
  return getTargetTariffType(state).group;
};
export var selectRegion = function selectRegion(state) {
  return getModalTariffData(state).region;
};
export var getOrderTariffCommonData = function getOrderTariffCommonData(state) {
  return getOrderTariffData(state).orderProgress || emptyObj;
};
export var getTariffDetailsFromStore = function getTariffDetailsFromStore(state) {
  return getOrderTariffData(state).tariffServices || emptyObj;
};
export var getAddressView = function getAddressView(state) {
  return getOrderTariffCommonData(state).addressView;
};
export var getCaptchaFlag = function getCaptchaFlag(state) {
  return selectCommonData(state).showCaptcha || false;
};
export var getIsOpenPopupFlag = function getIsOpenPopupFlag(state) {
  return getOrderTariffCommonData(state).isOpen;
};

// селекторы для текстов
export var getTariffDetailsTexts = function getTariffDetailsTexts(state) {
  return selectCommonData(state).texts || emptyObj;
};
export var getOrderTariffTexts = function getOrderTariffTexts(state) {
  var _getTariffDetailsText;
  return ((_getTariffDetailsText = getTariffDetailsTexts(state)) === null || _getTariffDetailsText === void 0 ? void 0 : _getTariffDetailsText.fullFormPopupTexts) || emptyObj;
};
export var getAddressRequestTexts = function getAddressRequestTexts(state) {
  return getOrderTariffTexts(state).addressRequestTexts || emptyObj;
};
export var getAddressNotAvailableTexts = function getAddressNotAvailableTexts(state) {
  return getOrderTariffTexts(state).notAvailableTexts || emptyObj;
};
export var selectActionHref = function selectActionHref(state) {
  return getAddressNotAvailableTexts(state).actionHref;
};
export var getIsPresetUpFlag = function getIsPresetUpFlag(state) {
  return getTargetTariffType(state).tariffType === TARIFF_TYPES.presetUp;
};
export var getAddressData = function getAddressData(state) {
  var _getOrderTariffData;
  return ((_getOrderTariffData = getOrderTariffData(state)) === null || _getOrderTariffData === void 0 ? void 0 : _getOrderTariffData.userData) || emptyObj;
};
export var getConnectionStatus = function getConnectionStatus(state) {
  return getModalTariffData(state).statusConnection;
};
export var getHighSpeedAvailableFlag = createSelector([getConnectionStatus, getIsHighSpeedTariff], function (status, isHighSpeedTariff) {
  return isHighSpeedTariff && status === POPUP_CONNECTION_STATE.highSpeedAvailable;
});
export var buildOrderQueryParams = createSelector([getTargetTariffType, getAddressData, getHighSpeedAvailableFlag], function (tariffData, userData, isHighSpeedAvailable) {
  var _userData$street$id, _userData$house$id;
  return getQueryParams({
    inacId: tariffData.inacId,
    street: userData.street.label,
    streetId: (_userData$street$id = userData.street.id) === null || _userData$street$id === void 0 ? void 0 : _userData$street$id.toString(),
    house: userData.house.label,
    houseId: (_userData$house$id = userData.house.id) === null || _userData$house$id === void 0 ? void 0 : _userData$house$id.toString(),
    flat: userData.flat,
    isHighSpeedAvailable: isHighSpeedAvailable
  });
});